var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"radio-component",on:{"click":_vm._toggleItem}},[(_vm.selected)?_c('i',{staticClass:"el-icon-circle-check lc-primary-color"}):_c('i',{staticClass:"iconfont lc-icon-uncheck",staticStyle:{"font-size":"14px"}}),_c('label',{staticClass:"radio-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }